import { Grid } from '@mui/material'
import { useSelector } from 'react-redux'
import { usePersonalizationEngineFilters } from '@/views/personalization-engine/hooks'

import { DateFilterEnum } from '@/enums'
import { ADMIN_VIEW } from '@/constants/brand'
import { ApplicationState } from '@/state/root.models'

import {
  DateFilterComponent,
  BrandFilterComponent,
  SearchByPlayerComponent,
} from './'
import BalanceFilterType from './balance.component'

type Props = {
  hideSearchByPlayer?: boolean
}

export const FiltersComponent = ({ hideSearchByPlayer }: Props) => {
  const { brand } = useSelector(({ auth }: ApplicationState) => auth)

  const {
    filters,
    date,
    handleChangeSearch,
    handleChangeDate,
    onChangeEndDate,
    onChangeStartDate,
  } = usePersonalizationEngineFilters()

  return (
    <Grid container spacing={1} justifyContent="end">
      {!hideSearchByPlayer && (
        <Grid item xs={brand.siteId === ADMIN_VIEW ? 2 : 3}>
          <SearchByPlayerComponent
            filters={filters}
            handleChangeSearch={handleChangeSearch}
          />
        </Grid>
      )}
      {brand.siteId === ADMIN_VIEW && (
        <Grid item xs={brand.siteId === ADMIN_VIEW ? 2 : 3}>
          <BrandFilterComponent
            filters={filters}
            handleChangeSearch={handleChangeSearch}
          />
        </Grid>
      )}
      <Grid item xs={brand.siteId === ADMIN_VIEW ? 2 : 3}>
        <BalanceFilterType
          filters={filters}
          handleChangeSearch={handleChangeSearch}
        />
      </Grid>
      <Grid item xs={date === DateFilterEnum.DATE_RANGE ? 6 : 3}>
        <DateFilterComponent
          date={date}
          filters={filters}
          handleChangeDate={handleChangeDate}
          onChangeEndDate={onChangeEndDate}
          onChangeStartDate={onChangeStartDate}
        />
      </Grid>
    </Grid>
  )
}
